import { render, staticRenderFns } from "./EditTenantDescription.vue?vue&type=template&id=36b416d9"
import script from "./EditTenantDescription.vue?vue&type=script&lang=js"
export * from "./EditTenantDescription.vue?vue&type=script&lang=js"
import style0 from "./EditTenantDescription.vue?vue&type=style&index=0&id=36b416d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports